import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs';
import { UUID_TEMPLATE_CHAR_PATTERN } from '../constants/validation-patterns.constant';

const MUTATION_METHODS = new Set(['POST', 'PUT', 'PATCH']);

function generateUuidV4(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Polyfill for environments without crypto.randomUUID (e.g. older WebViews)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(UUID_TEMPLATE_CHAR_PATTERN, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export const idempotencyInterceptor: HttpInterceptorFn = (req, next) => {
  if (!MUTATION_METHODS.has(req.method)) {
    return next(req);
  }

  const idempotencyKey = generateUuidV4();
  const mutationReq = req.clone({
    setHeaders: { 'Idempotency-Key': idempotencyKey },
  });

  return next(mutationReq).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (
        event instanceof HttpResponse &&
        event.headers.get('Idempotency-Replayed') === 'true'
      ) {
        // The server already processed this key — the operation ran exactly once.
        // Log so devs can diagnose duplicate submissions; callers must guard their
        // own side-effects (toasts, navigation) against firing a second time.
        console.warn(
          `[Idempotency] Replayed response for key ${idempotencyKey} on ${req.method} ${req.url}. ` +
            'The operation was already executed — suppress any duplicate side-effects.',
        );
      }
    }),
  );
};
